import { v4 as uuidv4 } from 'uuid'
import { getMbmUserIdCookieOptions, MBM_USER_ID_COOKIE } from '@/constants/cookies'

/**
 * Reads the MBM user id from `document.cookie` (client only).
 */
export function readMbmUserIdFromDocument(): string | null {
  if (typeof document === 'undefined') {
    return null
  }

  const value = `; ${document.cookie}`
  const parts = value.split(`; ${MBM_USER_ID_COOKIE}=`)
  if (parts.length !== 2) {
    return null
  }

  return parts.pop()?.split(';').shift() ?? null
}

/**
 * Writes the MBM user id cookie in the browser (client fallback when edge proxy did not set it).
 */
export function writeMbmUserIdToDocument(userId: string): void {
  if (typeof document === 'undefined') {
    return
  }

  const { path, secure, sameSite, maxAge } = getMbmUserIdCookieOptions()
  const secureFlag = secure ? '; Secure' : ''

  document.cookie = `${MBM_USER_ID_COOKIE}=${userId}; Path=${path}; Max-Age=${maxAge}; SameSite=${sameSite}${secureFlag}`
}

/**
 * Returns an existing MBM user id or creates one and persists it in the browser.
 */
export function ensureMbmUserId(): string {
  const existing = readMbmUserIdFromDocument()
  if (existing) {
    return existing
  }

  const newUserId = uuidv4()
  writeMbmUserIdToDocument(newUserId)
  return newUserId
}
